<template>
  <div class="steps-container form_wrapper block_progress">
      <div class="form_header">
        <div class="form_header_name">{{cardTitle}}</div>
        <div class="form_header_remarks"></div>
      </div>

      <div class="stepsblock">
        <!-- :active="stepsConfig.active" -->
        <el-steps
          :active="stepsConfig.active"
          :space="stepsConfig.space"
          align-center
          :center="true"
        >
          <template v-for="(item, index) in stepArray">
            <el-step
              :key="index"
              :title = item.title
              :description = item.description
              :class="{'no-line': item.lastOne, 'active-item': item.lastActive }"
              v-if="item.showStep == false?false: true"
            >
              <span slot="title" v-if="item.clickIcon?item.clickIcon:false">
                {{item.t+itle}}
                <i
                  class="el-icon-warning-outline warningblock"
                  @click="warningblock"
                ></i
              ></span>
              <template v-else slot="title">
                <span class="handle-item" v-if="item.slot" @click="handleClick(item.indexProp, item.id)">{{item.title}}</span>
                <span v-else>{{item.title}}</span>
              </template>
            </el-step>
          </template>
          <!-- <el-step
            v-if="lastOne.show"
            :class="lastOne.active?'active-item':''"
            title="项目调整"
            description=""
          ></el-step> -->
        </el-steps>
      </div>
    <Dialog :data="stepsConfig" ref="dialogpass" />
  </div>
</template>
<script>
import Dialog from "@/components/detail/rzzl_lxj/dialog";
export default {
  name: 'Steps',
  data() {
    return {}
  },
  /**
   * @param {String} cardTitle 标题
   * @param {Object} stepsConfig step流程参数 {active, space, auditLog}
   * @param {Array} stepData step流程参数,tite, description必传，描述可为空 [...{tite, description,showStep, clickIcon}]
   */
  props: {
    cardTitle: {
      type: String,
      default: '流程进度'
    },
    stepsConfig: {
      required: true,
      type: Object
    },
    stepArray: {
      required: true,
      type: Array
    },
    // 是否有项目调整项
    // lastOne: {
    //   type: Object,
    //   default: () => {
    //     return {
    //       show: false,
    //       active: false
    //     }
    //   }
    // }
  },
  components: {
    Dialog
  },
  methods: {
    warningblock() {
      this.$refs.dialogpass.showblock();
    },

    handleClick(prop, id) {
      this.$emit('stepClick', prop, id)
    }
  }
}
</script>
<style lang="scss">
.steps-container{
    height: 100%;
    margin: 0;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: #e9e9e9;
    border-radius: 10px;
    background-color: #fff;
    margin: 20px 0 !important;
  .handle-item{
    cursor: pointer;
  }
  .active-item{
    .el-step__head{
      color: #409EFF !important;
      border-color: #409EFF !important;
    }
    .el-step__title {
      color: #409EFF !important;
    }    
  }
  .progress_title {
    line-height: 45px;
    font-weight: 500;
    font-size: 15px;
    border-radius: 7px 7px 0 0px;
    background: rgb(233, 233, 233);
    text-indent: 15px;
  }
  .stepsblock {
    padding: 25px 15px;
  }
  .stepsblock .el-step__title.is-process {
    font-weight: 500;
  }
  
  .stepsblock .el-step__head.is-process,
  .stepsblock .el-step__title.is-process,
  .stepsblock .el-step__description.is-process {
    color: #c0c4cc;
    border-color: #c0c4cc;
    font-weight: 500;
  }
  .stepsblock .el-step.is-center .el-step__description {
    padding: 0;
  }
  .stepsblock .el-step__title {
    font-size: 12px;
  }
  .el-step__title.is-process{
       color: #666;     
   }

  .stepsblock .el-step__head.is-process{
    .el-step__title{
      color: #666 !important;
    }
  }

    .form_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-width: 0px;
      height: 60px;
      background-color: rgba(249, 249, 249, 1);
      padding: 0 20px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom: 1px rgba(233, 233, 233, 1) solid;

      .form_header_name {
        font-weight: 700;
        color: #333;
        font-size: 16px;
      }
      .form_header_remarks {
        color: #999999;
        font-size: 13px;
        .red_color {
          color: #ff3b30;
        }
      }
    }
    .form_content {
      padding: 20px 50px;
    }
    .no-line{
      .el-step__line{
        height: 0 !important;
      }
    }
}


// .label_name {
//   font-weight: 900;
//   color: #666666;
//   position: relative;
//   margin: 30px 0;
//   &::after {
//     content: "";
//     position: absolute;
//     top: 50%;
//     left: -15px;
//     transform: translate(0, -50%);
//     height: 18px;
//     width: 6px;
//     background-color: #409eff;
//   }}

/deep/.stepsblock .el-step__title {
  font-size: 12px;
}
/deep/ .el-step__title {
  color: #666666;
}
/deep/.el-step__description {
  color: #ccc;
}
</style>